import { QueuableRequestStatus } from '@cims-online/shared'
import GenericQueue from '../../../GenericQueue'
import {
  useCancelPhotoExportRequestMutation,
  useQueuedPhotoExportRequestsQuery,
} from 'schema'
import {
  DefaultMutationHookOptions,
  DefaultQueryHookOptions,
} from 'utils/defaults'
import { Space } from 'antd'
import { simpleSuccessNotification } from 'hooks/notificationHandler'
import { dateFormatter } from 'utils/dateFormatter'
import { useProjectContext } from 'context/ProjectContext'

const Queue: React.FC = () => {
  const { projectId } = useProjectContext()
  const { Queued, Generating } = QueuableRequestStatus
  const { data, loading, refetch } = useQueuedPhotoExportRequestsQuery({
    ...DefaultQueryHookOptions,
    variables: {
      photoExportRequestListInput: {
        projectId: { equals: projectId },
        statusId: { list: [Queued.id, Generating.id] },
      },
    },
  })
  const [cancel] = useCancelPhotoExportRequestMutation({
    ...DefaultMutationHookOptions,
    onCompleted: () =>
      simpleSuccessNotification('Photo Export Request successfully cancelled!'),
  })
  return (
    <GenericQueue
      refetch={refetch}
      fetching={loading}
      active={data?.photoExportRequests?.records?.find(
        ({ statusId }) => statusId === Generating.id
      )}
      queued={{
        requests:
          data?.photoExportRequests?.records?.filter(
            ({ statusId }) => statusId === Queued.id
          ) ?? [],
        onCancel: ({ id }) => cancel({ variables: { id } }),
      }}
      options={({
        json: {
          arguments: {
            createdDate: { from, to },
          },
        },
      }) => [
        {
          label: 'Created Date',
          children: (
            <Space size="small" align="center">
              {dateFormatter.shortDatetime(from)}-
              {dateFormatter.shortDatetime(to)}
            </Space>
          ),
        },
      ]}
    />
  )
}

export default Queue
